export default {
  API_ENDPOINT: 'https://obscure-journey-16541.herokuapp.com/api',
  TOKEN_KEY: process.env.TOKEN_KEY || 'auth'
};
